module.exports = __webpack_public_path__ + "img/Product4.5a2412be.svg";